import { NgModule } from 'ng-metadata/core';
import { CheckoutService } from './checkout.service';

import { CheckoutCartModule } from './cart/cart.module';
import { CheckoutSubmitModule } from './submit/submit.module';
import { CheckoutAccountModule } from './account/account.module';
import { CheckoutShippingModule } from './shipping/shipping.module';
import { CheckoutCartSummaryModule } from './cart-summary/cart-summary.module';
import { CheckoutConfirmationModule } from './confirmation/confirmation.module';
import { CheckoutPassportWizardModule } from './passport-wizard/passport-wizard.module';

@NgModule({
  imports: [
    CheckoutCartModule,
    CheckoutSubmitModule,
    CheckoutAccountModule,
    CheckoutShippingModule,
    CheckoutCartSummaryModule,
    CheckoutConfirmationModule,
    CheckoutPassportWizardModule,
  ],
  providers: [
    CheckoutService,
  ],
})
export class CheckoutModule { }



// WEBPACK FOOTER //
// ./resources/assets/js/components/checkout/checkout.module.ts